import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * Checkbox component wrapping the label -> input -> span pattern
 */
export default function Checkbox({
  id,
  name,
  label,
  value,
  onChange,
  className,
  otherColor,
  disabled,
  onClick,
}) {
  const labelClass = cx(
    {
      'm-checkbox': true,
      'm-checkbox--dynamic': !otherColor,
    },
    className,
  );
  return (
    <label htmlFor={id} className={labelClass}>
      <input
        id={id}
        type="checkbox"
        name={name}
        defaultChecked={value}
        onChange={onChange}
        readOnly={(onChange || onClick) ? null : true}
        disabled={disabled}
        onClick={onClick}
      />
      {label}
      <span />
    </label>
  );
}

Checkbox.propTypes = {
  /** Input html id */
  id: PropTypes.string.isRequired,
  /** Input html name */
  name: PropTypes.string,
  /** Label text shown */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Checkbox input value, true or false */
  value: PropTypes.bool.isRequired,
  /** Change handler, should negate the previous value. If not given the component will be read only */
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  /** String of class names to be passed on to the wrapping <label /> */
  className: PropTypes.string,
  /** Not based on tenant color */
  otherColor: PropTypes.bool,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  name: '',
  label: '',
  onChange: null,
  onClick: null,
  className: '',
  otherColor: false,
  disabled: false,
};
